import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { LoadingSpinnerComponent } from './shared/components/loading/loading-spinner.component';
import { CallbackResolver } from './shared/resolvers/callback.resolver';

const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    children: [
      { path: 'auth', loadChildren: () => import('./auth/auth.routing').then(m => m.AUTH_ROUTES) },
      { path: 'home', loadChildren: () => import('./home/home.routing').then(m => m.HOME_ROUTES) },
      {
        path: 'orders',
        loadChildren: () => import('./orders/orders.routing').then(m => m.ORDERS_ROUTES)
      },
      {
        path: 'callback',
        resolve: {
          callback: CallbackResolver
        },
        component: LoadingSpinnerComponent
      },
      { path: '**', redirectTo: '/auth/login' }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
